import React from 'react';
import VideoGuidaFinestra from '../support/guide/VideoGuidaFinestra';

/**
 * Video guida «I verbali delle riunioni» per i rappresentanti (YouTube, 5 minuti).
 * Pulsante + finestra col video, nella pagina del verbale e in quella di creazione dell'evento.
 */
export const VIDEO_GUIDA_VERBALI_ID = 'NCMyvSA5aM8';

export const VIDEO_GUIDA_VERBALI_TITLE = 'Video guida ai verbali delle riunioni';

interface VideoGuidaVerbaliProps {
  /** `testata`: pulsante chiaro sulla testata verde del verbale; `pagina`: pulsante su fondo bianco. */
  variante?: 'testata' | 'pagina';
}

const VideoGuidaVerbali: React.FC<VideoGuidaVerbaliProps> = ({ variante = 'pagina' }) => (
  <VideoGuidaFinestra videoId={VIDEO_GUIDA_VERBALI_ID} titolo={VIDEO_GUIDA_VERBALI_TITLE} durata="5 minuti" variante={variante} />
);

export default VideoGuidaVerbali;
